<template>
    <div class="section track-form">
        <div class="track-head">Track your shipment</div>
        <div class="field">
            <label class="label track-by">Track by,</label>
            <div class="control track-inputs">
                <label class="radio">
                    <input
                        type="radio"
                        name="tracking_id_type"
                        value="awb_numbers"
                        id="awb_no"
                        @change="changeSearchBy"
                        :checked="searchBy == 'awb_numbers'"
                    />
                    AWB Number </label
                ><label class="radio">
                    <input
                        type="radio"
                        name="tracking_id_type"
                        value="shipment_numbers"
                        id="shipment_no"
                        @change="changeSearchBy"
                        :checked="searchBy == 'shipment_numbers'"
                    />
                    Shipment Number
                </label>
                <label class="radio">
                    <input
                        type="radio"
                        name="tracking_id_type"
                        value="reference_numbers"
                        id="reference_no"
                        @change="changeSearchBy"
                        :checked="searchBy == 'reference_numbers'"
                    />
                    Order Number
                </label>
            </div>
        </div>
        <div class="field">
            <div class="control">
                <input
                    class="input is-medium"
                    type="text"
                    ref="tracking_ids"
                    name="tracking_ids[]"
                    v-model="trackingIds"
                    :placeholder="placeholder"
                    @keyup.enter="submit"
                />
            </div>
            <p class="help">
                <strong>Note</strong>: You can enter multiple Tracking IDs (upto
                20) separated by <strong>','</strong> for tracking multiple
                shipments.
            </p>
        </div>
        <div class="field">
            <div class="control">
                <button
                    class="button is-link"
                    @click="submit"
                    :disabled="submitting"
                >
                    Track Shipment
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        entityId: {
            required: true
        }
    },
    data() {
        return {
            searchBy: "shipment_numbers",
            trackingIds: "",
            errors: {},
            placeholder: "Enter Shipment Numbers here to track your shipment",
            submitting: false
        };
    },
    async mounted() {
        let trackingIds = decodeURIComponent(window.location.search).replace(
            "?",
            ""
        );
        this.$refs.tracking_ids.focus();
        trackingIds = new URLSearchParams(trackingIds);
        const entries = Object.fromEntries(trackingIds.entries());
        if (entries.hasOwnProperty("tracking_ids")) {
            this.trackingIds = entries.tracking_ids;
            this.searchBy = entries.tracking_id_type;
            await this.submit();
        }
    },
    computed: {
        trackUrl() {
            return `${process.env.VUE_APP_E3_URL}/track?`;
        },
        subDomain() {
            let hostname = window.location.hostname;
            if (hostname.includes("www.")) {
                hostname = hostname.replace("www.", "");
            }
            if (!hostname.includes(".")) {
                return null;
            }
            const subdomains = hostname.split(".");
            return subdomains[0];
        }
    },
    methods: {
        getError(name) {
            if (this.errors.hasOwnProperty(name)) {
                return "* " + this.errors[name][0];
            }
        },

        changeSearchBy(e) {
            this.searchBy = e.target.value;
            let field = this.searchBy.split("_").join(" ");
            this.placeholder = `Enter ${field} here to track your shipment`;
            this.$refs.tracking_ids.focus();
        },

        async track(url) {
            const response = await fetch(url);
            if (!response.ok) {
                const responseErrors = await response.json();
                this.errors = responseErrors["errors"];
                return;
            }

            const data = await response.json();
            this.$emit("display-track", {
                data: data["data"],
                tracking_id_type: this.searchBy,
                tracking_ids: this.trackingIds
            });
        },

        async submit() {
            this.submitting = true;

            try {
                let value = this.trackingIds;

                if (value.includes(",")) {
                    value = value.split(",");
                } else {
                    value = [value];
                }

                const url = new URL(this.trackUrl);

                url.searchParams.append("tracking_id_type", this.searchBy);

                value.forEach((element, index) => {
                    url.searchParams.append(`tracking_ids[${index}]`, element);
                });

                if (this.entityId) {
                    url.searchParams.append(
                        "accounts_entity_id",
                        this.entityId
                    );
                }

                await this.track(url);
            } catch (error) {
                console.log(error);
            } finally {
                this.submitting = false;
            }
        }
    }
};
</script>

<style scoped>
.field {
    margin-top: 30px;
    margin-bottom: 30px;
}
.radio {
    margin-left: 10px;
}

.track-head {
    font-size: 2.4rem;
    font-weight: 700;
    text-align: center;
}

.track-by {
    font-size: 1.4rem;
    letter-spacing: 1.2px;
}

.track-inputs label {
    font-size: 1.2rem;
    letter-spacing: 1.4px;
    font-weight: 500;
}

.help {
    font-size: 1.1rem;
}

@media screen and (max-width: 768px) {
    .radio {
        display: block;
        margin-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Form.vue